import Avaliacao from './components/Index'

export default [
  {
    path: '/avaliacao',
    component: Avaliacao,
    name: 'avaliacao',
    meta: {
      breadcrumb: {
        name: 'Avaliação on-line'
      },
      auth: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/avaliacao/routes.js